import React from 'react';
import {
  IonContent,
  IonList,
  IonItem,
  IonIcon,
  IonLabel,
  IonButton,
  IonHeader,
  IonToolbar,
  IonImg,
} from '@ionic/react';
import {
  linkOutline,
  addCircleOutline,
  settingsOutline,
  logOutOutline,
} from 'ionicons/icons';
import { useAuth } from '../../auth/contexts/AuthContext';
import styles from '../Dashboard.module.css';

export const Sidebar: React.FC = () => {
  const { logout } = useAuth();

  return (
    <>
      <IonHeader className={styles.sidebarHeader}>
        <IonToolbar className={styles.sidebarToolbar}>
          <IonItem routerLink="/" routerDirection="root" lines="none" className={styles.logoItem}>
            <IonImg 
              src="/Logo_Horizontal.png" 
              alt="LinkSharePro Logo"
              className={styles.sidebarLogo}
            />
          </IonItem>
        </IonToolbar>
      </IonHeader>

      <IonContent className={styles.sidebarContent}>
        <IonList className={styles.sidebarList}>
          <IonItem routerLink="/links" routerDirection="none" lines="none">
            <IonIcon slot="start" icon={linkOutline} />
            <IonLabel>Links</IonLabel>
          </IonItem>

          <IonButton 
            expand="block"
            routerLink="/links/new"
            routerDirection="root"
          >
            <IonIcon slot="start" icon={addCircleOutline} />
            New Link
          </IonButton>

          <IonItem routerLink="/settings" routerDirection="none" lines="none">
            <IonIcon slot="start" icon={settingsOutline} />
            <IonLabel>Settings</IonLabel>
          </IonItem>

          <IonItem button onClick={() => logout()} lines="none">
            <IonIcon slot="start" icon={logOutOutline} />
            <IonLabel>Sign Out</IonLabel>
          </IonItem>
        </IonList>
      </IonContent>
    </>
  );
}; 